module.exports = __webpack_public_path__ + "static/media/HEK.d6e5fb67.svg";